import 'choices.js/public/assets/styles/choices.min.css';
import '@fortawesome/fontawesome-free/css/all.css';
import 'cropperjs/dist/cropper.css';
import '../sass/project.scss';
import { initializeTable, initializeTableFilter } from './tables/tables';
import { initializeTabulatorScrollbars } from './tables/tabulatorScrollbars';
import initializeManualsTable, {
    setupManualsPageInteractions,
} from './tables/definitions/manuals-table';
import utils, { initializeDependentGroupTypeSelects } from './utils';
import alerts from './alerts';
import { DateTime } from 'luxon';
import './scanner';
import './fileGallery';
import { initializePings } from './pings';
import { initializeCatalogModule } from './catalog';
import initTiny from './initTiny';

import {
    initializeFormsets,
    setupFormListeners,
    initializeSelect,
    initializePhotoLayout,
    initializeBannerForm,
    initializeStepSelect,
    initializeOrdering,
    initializeDeleteButtons,
    initializePublishButton,
} from './manuals/form';
import {
    initializeDisassemblyActions,
    initializeDisassemblyComments,
    initializeDisassemblySidePanel,
    initializeEnovaForm,
    initializeSendEmailForm,
    checkAndUpdateTips,
    initializeCleaningActions,
    initializeTimeTracker,
    initializeLabelPrinting,
} from './disassembly/form';
import initializeExecutionsTable from './tables/definitions/executions-table';
import {
    initializeKEPConfigUI,
    initializeKEUConfigUI,
} from './tables/definitions/enovaFields-table';
import { initializeWindows } from './windows';
import { initializeNotifications } from './notifications';
import { initializeSessionTimeout } from './sessionTimeout';
import initializeMailRecipientsTable from './tables/definitions/mail-recipients-table';
import initializeUsersTable from './tables/definitions/users-table';
import initializeComponentListTable from './tables/definitions/component-list-table';
import initializeGlobalComponentsTable from './tables/definitions/global-components-table';
import initializeOfferListTable from './tables/definitions/offer-list-table';
import initializeComponentTypeListTable from './tables/definitions/component-type-list-table';
import initializeMeasurementConfigTable from './tables/definitions/measurement-config-table';
import { initializeComponentCard } from './tables/definitions/component-card';
import initializePermissionsMatrix from './tables/definitions/permissions-table';
import { initializeCreateOfferPopup } from './woocommerce/create-offer-popup';
import { initializeCreateGlobalComponentPopup } from './disassembly/create-global-component-popup';
import initializeReportTable from './tables/definitions/reports-table';
import initializeNotificationLogsTable from './tables/definitions/notifications-table';
import './date_picker';
import { initializeReportPopup } from './reports/report-popup.js';
import initializeDeviceListTable from './tables/definitions/device-list-table';
import { initializeDeviceCard } from './tables/definitions/device-card';
import { initializePhotoPreview } from './tables/definitions/initialize-photo-preview';
import initializeDictionariesTable from './tables/definitions/dictionaries-table';

window.tables = {
    initializeTable: initializeTable,
    setupManualsPageInteractions: setupManualsPageInteractions,
    initializeManualsTable: initializeManualsTable,
    initializeComponentListTable: initializeComponentListTable,
    initializeGlobalComponentsTable: initializeGlobalComponentsTable,
    initializeOfferListTable: initializeOfferListTable,
    initializeComponentTypeListTable: initializeComponentTypeListTable,
    initializeMeasurementConfigTable: initializeMeasurementConfigTable,
    initializeMailRecipientsTable: initializeMailRecipientsTable,
    initializeUsersTable: initializeUsersTable,
    initializeComponentCard: initializeComponentCard,
    initializeDeviceListTable: initializeDeviceListTable,
    initializeDeviceCard: initializeDeviceCard,
    initializeTableFilter: initializeTableFilter,
    initializeExecutionsTable: initializeExecutionsTable,
    initializeKEPConfigUI: initializeKEPConfigUI,
    initializeKEUConfigUI: initializeKEUConfigUI,
    initializePhotoPreview: initializePhotoPreview,
    initializeReportTable: initializeReportTable,
    initializePermissionsMatrix: initializePermissionsMatrix,
    initializeDictionariesTable: initializeDictionariesTable,
    initializeNotificationLogsTable: initializeNotificationLogsTable,
};

window.alerts = {
    initializeAlert: alerts.initializeAlert,
    addAlert: alerts.addAlert,
};

window.DateTime = DateTime;

window.manuals = {
    setupFormListeners,
    initializeFormsets,
    initializePhotoLayout,
    initializeBannerForm,
    initializeStepSelect,
    initializeOrdering,
    initializeDeleteButtons,
    initializePublishButton,
};

window.disassembly = {
    initializeDisassemblyActions,
    initializeDisassemblyComments,
    initializeDisassemblySidePanel,
    initializeCleaningActions,
    initializeEnovaForm,
    initializeSendEmailForm,
    checkAndUpdateTips,
    initializeTimeTracker,
    initializeLabelPrinting,
};

window.forms = {
    initializeSelect,
    initializeDependentGroupTypeSelects,
};

window.catalog = {
    initializeCatalogModule,
};

window.utils = {
    toggleAreaExpanded: utils.toggleAreaExpanded,
    hideOnClickOutside: utils.hideOnClickOutside,
};

window.windows = {
    initializeWindows: initializeWindows,
};

window.popups = {
    initializeCreateOfferPopup: initializeCreateOfferPopup,
    initializeReportPopup: initializeReportPopup,
    initializeCreateGlobalComponentPopup: initializeCreateGlobalComponentPopup,
};

window.addEventListener('DOMContentLoaded', async function () {
    utils.handleMobileMenu();
    utils.initializeClock();
    alerts.initializeRedirectAlertHandler();

    initTiny();
    initializeWindows(document);
    initializeNotifications();
    initializeSessionTimeout();
    initializePings(document);
    initializeTabulatorScrollbars();

    const url = new URL(window.location.href);
    if (url.searchParams.has('kodStanowiska')) {
        url.searchParams.delete('kodStanowiska');
        const newUrl =
            url.pathname +
            (url.searchParams.toString()
                ? '?' + url.searchParams.toString()
                : '');
        window.history.replaceState({}, '', newUrl);
    }

    const loadedEvent = new Event('bundleLoaded');
    document.dispatchEvent(loadedEvent);
});
